const classPrefix = 'footer'
const dataPrefix = 'data-footer'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    footer()
}
export function footer() {


}
